import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface InfiniteScrollRedirectProps {
  redirectTo: string;
}

const InfiniteScrollRedirect: React.FC<InfiniteScrollRedirectProps> = ({ redirectTo }) => {
  const navigate = useNavigate();

  // Função que detecta quando o usuário chega ao final da página
  const handleScroll = (navigate: (path: string) => void) => {
    const scrollTop = document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Verifica se o usuário está perto do final da página
    if (windowHeight + scrollTop + 10 >= documentHeight) {
      // Redireciona para a página passada por props
      navigate(redirectTo);
      
      // Suavemente sobe para o início da nova página
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    // Adiciona o evento de rolagem na montagem do componente
    const onScroll = () => handleScroll(navigate);
 

    // Remove o evento de rolagem quando o componente desmonta
    return () => window.removeEventListener('scroll', onScroll);
  },);

  return null;
};

export default InfiniteScrollRedirect;
